import { Component, OnInit, ViewChild } from '@angular/core';

import { AuthService } from '@app/shared/auth/auth.service';
import swal from 'sweetalert2';
import { Router } from '@angular/router';


@Component({
	selector: 'app-forgotpasswd',
	templateUrl: './forgotpasswd.component.html',
	styleUrls: ['./forgotpasswd.component.scss']
})
export class ForgotpasswdComponent implements OnInit {

	model: any = {};
	submitted = false;
	today = new Date();

	constructor(
		private auth: AuthService,
		private router: Router
	) { }

	ngOnInit() {
	}

	onSubmit() {
		this.submitted = true;
        this.auth.forgotPassword(this.model.email).subscribe(
            (data: any) => {
				this.submitted = false;
				swal(data,'','success');
				this.router.navigate(['/auth/login']);
            }, error => {
				this.submitted = false;
                swal(error.error.error,'','error');
            })
    }

}
